import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextParser from '../StructuredTextParser';

// Define the props interface for the main component
interface OnlineInPersonTabsProps {
  sectionId: string;
  section: any;
  region?: string;
  lang?: string;
}

const OnlineInPersonTabCommonHeader: React.FC<OnlineInPersonTabsProps> = ({
  section,
  region,
  lang,
}) => {
  return (
    <Box px={{ base: 3, md: 4 }} pt={{ base: '53px', md: '100px' }} mx="auto" w="100%">
      <Text
        fontFamily="FedraSansStd-medium"
        fontSize={{ base: '32px', md: '64px' }}
        color="#3B444B"
        textAlign={'center'}
        lineHeight={'110.00000000000001%'}
        fontWeight={500}
      >
        {section[0]?.titleText}
      </Text>

      <Box maxW={'600px'} mx={'auto'}


        mt={{ base: '13px', lg: 1 }}
      >
        <StructuredTextParser
          str={render(section[1]?.body)}
          fontFamily="FedraSansStd-book"
          // className="innerEngineeringText"
          fontSize={{ base: '18px', md: '18px' }}
          lineHeight={{ base: '140%', xl: '27px' }}
          color={'#52483D'}
          textAlign={'center '}
          region={region}
          lang={lang}
        />
      </Box>
    </Box>
  );
};

export default OnlineInPersonTabCommonHeader;
